import React from 'react';
import { Helmet } from 'react-helmet';
import { graphql, StaticQuery } from 'gatsby';

export default function SEO({title, image, description, url, twitterUsername, author, keywords}){
    return (
        <StaticQuery
            query={detailsQuery}
            render={
                data=>{
                    const metaDescription = description || data.site.siteMetadata.description
                    const metaTitle = title || data.site.siteMetadata.title
                    const metaAuthor = author || data.site.siteMetadata.author
                    const metaURL = url || data.site.siteMetadata.url
                    const metaImage = image || data.site.siteMetadata.image
                    const metaKeywords = keywords || ["Aditya Mudgil", "personal website"]
                    return(
                        <Helmet
                            title = {title}
                            meta = {[
                                {
                                    name: 'description',
                                    content: metaDescription
                                },
                                {
                                    name: 'og:title',
                                    content: metaTitle
                                },
                                {
                                    name: 'og:description',
                                    content: metaDescription
                                },
                                {
                                    name: 'og:type',
                                    content: 'website'
                                },
                                {
                                    name: 'og:image',
                                    content: metaImage
                                },
                                {
                                    name: 'og:url',
                                    content: metaURL
                                },
                                {
                                    name: 'twitter:card',
                                    content: 'summary_large_image'
                                },
                                {
                                    name: 'twitter:creator',
                                    content: metaAuthor
                                },
                                {
                                    name: 'twitter:title',
                                    content: metaTitle
                                },
                                {
                                    name: 'twitter:description',
                                    content: metaDescription
                                },
                                {
                                    name: 'twitter:image',
                                    content: metaImage
                                }
                            ].concat(
                                metaKeywords && metaKeywords.length > 0 ? {
                                    name: 'keywords',
                                    content: metaKeywords.join(', ')
                                }: []
                            )
                            }
                        />
                    )
                }
            }
        />
    )
}
export const detailsQuery = graphql`
    query DefaultSEOQuery {
        site {
            siteMetadata {
                title
                image
                description
                url
                twitterUsername
                author
            }
        }
    }
`